import React from 'react'
import { HubCompanyChallengeSolutionsManagement } from 'domain/feature/hub/company/challenge/solutions'

export const HubCompanyChallengeSolutionsPage = (): JSX.Element => {
  return (
    <HubCompanyChallengeSolutionsManagement />
  )
}
